export const navigateRoutes = {
  signIn: '/sign-in',

  savedContacts: '/saved-contacts',

};
